import { QueryFactory } from '@lmt/shared-types';
import {
  logOut,
  useClaims,
} from '@lmt/unicorn-shared/app/features/auth/operations';
import { QuerySuspenseErrorWrapper } from '@lmt/unicorn-shared/app/helpers/retry-helper';
import { usePrefetchQueries } from '@lmt/unicorn-shared/app/usePrefetchQueries';
import React, { FC, useEffect } from 'react';
import { IdleTimerProvider } from 'react-idle-timer';
import { SignalRHandler } from '../signalr/SignalRHandler';

function useConfigureQueriesAccordingToPermissions() {
  const claims = useClaims();
  useEffect(() => {
    QueryFactory.HL7OutgoingSettingsQuery.setGetDefaultOptions({
      ...QueryFactory.HL7OutgoingSettingsQuery.getGetDefaultOptions(),
      enabled: claims.permissions.hl7 || claims.permissions.hl7Management,
    });
    QueryFactory.HL7SettingsQuery.setGetDefaultOptions({
      ...QueryFactory.HL7SettingsQuery.getGetDefaultOptions(),
      enabled: claims.permissions.hl7 || claims.permissions.hl7Management,
    });
  }, [claims.permissions.hl7, claims.permissions.hl7Management]);
}

export const InactivityWatcher: FC<React.PropsWithChildren> = (props) => {
  const { data: settings } = QueryFactory.SecuritySettingsQuery.useGetQuery({
    throwOnError: false,
  });

  return (
    <IdleTimerProvider
      timeout={(settings?.idleLogoutTimeoutMinutes ?? 10000) * 60 * 1000}
      stopOnIdle={true}
      onIdle={logOut}
      disabled={!settings?.idleLogoutTimeoutMinutes}
    >
      {props.children}
    </IdleTimerProvider>
  );
};

export const LoginLoader: FC<React.PropsWithChildren> = (props) => {
  useConfigureQueriesAccordingToPermissions();
  usePrefetchQueries();

  return (
    <QuerySuspenseErrorWrapper>
      <InactivityWatcher>
        <SignalRHandler />
        {props.children as React.ReactElement<any>}
      </InactivityWatcher>
    </QuerySuspenseErrorWrapper>
  );
};
